import { gql } from '@apollo/client';
import { DataExportStates } from '@generated/graphql';

export const EXPORT_API_REPORT = gql`
  mutation exportApiReport($input: ExportApiReportInput!) {
    exportApiReport(input: $input) {
      apiExport {
        id
      }
    }
  }
`;

export const FETCH_API_EXPORT = gql`
  query fetchApiExport($input: FetchApiExportInput!) {
    fetchApiExport(input: $input) {
      apiExport {
        id
        progress
        state
        fileUrl
      }
    }
  }
`;

export const API_EXPORT_STATES = {
  generating: DataExportStates.Generating,
  completed: DataExportStates.Completed,
  failed: DataExportStates.Failed,
} as const;
